/**
 * Created by tong on 2018/2/2.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Input} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from 'Components';
import {list, updatePurchase} from '../../service/purchaseUnit'
/*购货单位列表接口*/
import {Store, Actions} from './store';
import {getGouXiaoUnitList} from "../../service/traceOrder";
import {openNotice} from "../../utils";

class PurchaseUnitList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.fatherCode = this.props.location.query.fatherCode || null;
        this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.state = {
            rows: [],
            total: 0,
            searchObj: {
                fatherCode: this.fatherCode,
                s: 10,
                p: 1,
                fatherId: this.userData.thirdId,
                channelCode: this.channelData.split('|')[1] || '',
                name: ''
            },
            loading: true
        };
        this.getData = this.getData.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    /*离开当前路由时，更新store*/
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'store' && path[2] !== 'detail') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    };

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    fatherCode: this.fatherCode,
                }
            });
        }
    };

    componentDidMount() {
        this.mounted = true;
        this.getData();
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.name
                    })
                }
                this.setState({gouxiaoUnitList: arr})
            }
        });
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    };

    /*获取页面列表*/
    getData() {
        const self = this;
        const {searchObj} = this.state;
        list(searchObj).then(res => {
            if (res.status) {
                self.setState({total: res.total, rows: res.data, loading: false});
            } else {
                console.error(res.message);
                this.setState({loading: false});
            }
        });
    }

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    }

    /*返回*/
    backTo() {
        window.history.go(-1);
    }

    /*筛选*/
    setFilterParam(name, value) {
        // console.log(name + ':\t' + value);
        if (name === 'lastOperationTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*筛选重置*/
    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                s: 10,
                p: 1,
                name: ''
            }, loading: true
        }, () => {
            self.getData();
        })
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        const self = this;
        this.setState({
            searchObj: {...this.state.searchObj, p: 1}, loading: true
        }, function () {
            self.getData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.getData();
        });
    };

    editAddress(record) {
        const {rows} = this.state;
        rows.forEach(item => {
            if (item.id === record.id) {
                item.edit = true;
            }
        })
        this.setState({
            rows: this.state.rows
        });
    }

    saveAddress(record) {
        const {rows} = this.state;

        if (record.receiptEmail) {
            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            if (!emailRegex.test(record.receiptEmail)) {
                openNotice('error', '请输入有效的邮箱地址', '');
                return;
            }
        }
        if (record.receiptPhone) {
            const phoneRegex = /^[1-9][0-9]{10}$/;
            if (!phoneRegex.test(record.receiptPhone)) {
                openNotice('error', '请输入有效的手机号码', '');
                return;
            }
        }

        updatePurchase(record).then(res => {
            if (res.code === 200) {
                openNotice('success', '修改成功', '');
                rows.forEach(item => {
                    if (item.id === record.id) {
                        item.edit = false;
                    }
                });
                this.setState({
                    rows: this.state.rows
                })
            }
        })
    }

    changeInput(e, record, type) {
        const {rows} = this.state;
        rows.forEach(item => {
            if (item.id === record.id) {
                item[type] = e.target.value;
            }
        });
        this.setState({
            rows: this.state.rows,
        });
    }

    render() {
        const {rows, total, searchObj, loading, gouxiaoUnitList} = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'name',
                    label: '购货单位',
                    text: '输入购货单位',
                    defaultValue: searchObj.name,
                    type: 'select',
                    showSearch: true,
                    options: gouxiaoUnitList
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'id'
                },
                {
                    title: '编号',
                    dataIndex: 'code'
                },
                {
                    title: '购货单位',
                    dataIndex: 'name',
                    render: (text, record, index) => {
                        return <a href={`#/purchaseUnit/${record.id}`}>{text}</a>
                    }
                },
                {
                    title: '开单权限',
                    dataIndex: 'orderType',
                    render: (text, record, index) => {
                        let _arr = [];
                        if (record.ordinaryOrderFlag === 'Y') {
                            _arr.push('常规订单');
                        }
                        if (record.terminalOrderFlag === 'Y') {
                            _arr.push('项目订单');
                        }
                        if (record.vipOrderFlag === 'Y') {
                            _arr.push('大客户订单');
                        }
                        return _arr.join('，');
                    }
                },
                {
                    title: '付款条件',
                    dataIndex: 'payment'
                },
                {
                    title: '发票接收号码',
                    dataIndex: 'receiptPhone',
                    width: 200,
                    render: (text, record) => (record.edit ?
                        <Input value={text} onChange={(e) => {
                            this.changeInput(e, record, 'receiptPhone')
                        }}/> : text)
                },
                {
                    title: '发票接收邮箱',
                    dataIndex: 'receiptEmail',
                    width: 200,
                    render: (text, record) => (record.edit ?
                        <Input value={text} onChange={(e) => {
                            this.changeInput(e, record, 'receiptEmail')
                        }}/> : text)
                },
                {
                    title: '操作',
                    render: (text, record, index) => {
                        if (record.edit) {
                            return <div>
                                <Button type="primary"
                                        onClick={() => {
                                            this.saveAddress(record)
                                        }}
                                >保存
                                </Button></div>
                        } else {
                            return <div>
                                <Button
                                    onClick={() => {
                                        this.editAddress(record)
                                    }}
                                >修改</Button>
                            </div>
                        }
                    }
                }
            ],
            rows
        };
        let self = this;
        let backHide = (fatherCode) => {
            if (fatherCode) {
                return <Button onClick={self.backTo.bind(self)}>返回</Button>
            } else {
                return '';
            }
        };
        return <div className="dms-body">
            <DmsTab options={['购货单位列表']} defaultKey={0}>
                {backHide(this.fatherCode)}
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

export default withRouter(PurchaseUnitList);


// WEBPACK FOOTER //
// ./src/routes/purchaseUnit/list.js